import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper, Btn } from '../../_components'
import Table from '../../_components/Table'
import Axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { getRegisteredFarmers } from '../../_slices/AppSlice'

// const cooperative = [
//     "Chairperson", "Vice Chairperson","Secretary Finance", "General Secretary", "Secretary Production", "Secretary Marketing", "Secretary Processing", "Secretary Communication and Mobilization", "Secretary Legal Affairs"
// ]
// const iwua = [ "Chairperson", "Vice Chairperson", "General Secretary", "Treasurer", "Mobilizer", "Executive Member" ]
// const iwuc = [ "Chairperson", "Vice Chaiperson", "Secretary", "Treasurer", "Mobilizer" ]
// const group = [ "Chairperson",  "Vice Chaiperson", "Secretary", "Treasurer", "Mobilizer"]

const PositionField = record => {

    const displayTitle = () => {
        switch( record.value ) {
            case "GS":
                return "General Secretary"
            case "VC":
                return "Vice Chairperson"
            case "Chairperson":
                return "Chairperson"
            case "SF":
                return "Secretary Finance"
            case "SProd":
                return "Secretary Production"
            case "SM":
                return "Secretary Marketing"
            case "SProc":
                return "Secretary Processing"
            case "SComms":
                return "Secretary Communication & Mobilization"
            case "SLegal":
                 return "Secretary Legal Affairs"
            default:
                break;
        }
    }
    return (
        <div className="text-start text-xs font-bold">
            {displayTitle()}
        </div>
    )
}

const ActionField = record => {
    const deActivate = async ( id ) => {
        try {
            const response = await Axios.post( `https://mis.nec.go.ug/api/auth/fiefoc_deactivate`, {
                id,
                flag: "deactivate"
            } ) 
            if( response.data ) {
               return window.location.reload()
            }
        } catch (error) {
            
        }
    } 
    const activate = async ( id ) => {
        try {
            const response = await Axios.post( `https://mis.nec.go.ug/api/auth/fiefoc_deactivate`, {
                id,
                flag: "activate"
            } ) 
            if( response.data ) {
               return window.location.reload()
            }
        } catch (error) {
            
        }
    } 

    const navigateTo = async ( id, tag ) => {
        await localStorage.setItem( "farmerId", id )
        await localStorage.setItem( "tag", tag )

        if( tag === "view" ) {
            await localStorage.setItem( "name", "register_farmer" )
            return window.location.reload()
        }
        
        if( tag === "edit" ) {
            await localStorage.setItem( "name", "register_farmer" )
            return window.location.reload()
        }
        
        if ( tag === "deactivate" ) {
            alert( "Do you want to deactivate the Leader?" )
            await deActivate( id )
        }

        if ( tag === "activate" ) {
            alert( "Do you want to re-activate this Leader?" )
            await activate( id )
        }
    }

    return (
        <div className="flex items-center">
            <Btn handlePress={() => navigateTo( record.value, "view")} label="View" color={`#8A3FFC`} />
            <Btn handlePress={() => navigateTo( record.value, "edit")} label="Edit" color={`#3F84FC`} />
            <Btn handlePress={() => navigateTo( record.value, ( record?.row.original.status === "1" ? "deactivate" : "activate" ) )} label={`${record?.row.original.status === "1" ? "Deactivate" : "Re-Activate" }`} color={`${ record?.row.original.status === "1" ? "#FC413F": "purple"}`} />
        </div>
    )
}

export default function AllLeaders() {
    const dispatch = useDispatch()
    const state = useSelector( state => {
        return {
           farmers: state.application.farmers,
           loading: state.application.loading
        }
    } )
    let leaderType = localStorage.getItem( "leaderType" )

    const leaderColumns = useMemo(
        () => [
            {
                Header: "#",
                accessor: "fId"
            },
            {
                Header: "Position",
                accessor: "position",
                Cell: PositionField
            },
            {
                Header: "Name",
                accessor: "name"
            },
            {
                Header: "Registration #",
                accessor: "registration_no"
            },
            {
                Header: "Block #",
                accessor: "block"
            },
            {
                Header: "Group",
                accessor: "ffs_code"
            },
            {
                Header: "Plot #",
                accessor: "plotno"
            },
            {
                Header: "Actions",
                accessor: "id",
                Cell: ActionField
            }
        ]
    )

    // const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( false )

    useEffect( () => {
        if( !(state.farmers.length > 0 ) ){
            dispatch( getRegisteredFarmers() )
        }
    }, [ state.farmers ] )


    if( loading ) {
        return (
            <Wrapper>
                <div className="flex flex-col">
                    {`Loading...`}
                </div>
            </Wrapper>
        )
    }

    // console.log(  )
    // console.log( "type", leaderType )
    
    return (
    <Wrapper>
     <div className="flex flex-col">
        <h2 className="text-lg">
            {`${leaderType?.toUpperCase()} Leader Positions`}
        </h2>
        {state.loading ?  (
            <div className="flex flex-col items-center justify-center">
                {`Loading Leaders...`}
            </div>
        ) : ( <Table
            label="All Leaders"
            columns={leaderColumns}
            data={state.farmers.filter( person => {
                return person.is_leader?.toUpperCase() === "YES" && leaderType?.toLowerCase() === "group" ? person.institution_type?.toUpperCase() === "FFSG" : person.institution_type?.toLowerCase() === leaderType?.toLowerCase()
            } ).map( ( record, idx ) => ( { ...record, fId: parseInt( idx + 1 ) } ) ).sort( ( a, b ) => {
                return b.fId > a.fId
            } )}
            hidePagination={false}
        /> ) }
     </div>
    </Wrapper>
  )
}
